import { useState } from "react";
import { ChevronDown } from "lucide-react";

// قسم قابل للطي: عنوان + أيقونة + محتوى يظهر/يختفي.
export const Collapsible = ({ icon: Icon, title, defaultOpen = false, children, testid }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="rounded-2xl bg-background shadow-neu-sm" data-testid={testid}>
      <button type="button" onClick={() => setOpen(!open)}
              data-testid={`${testid}-toggle`}
              className="flex w-full items-center justify-between gap-3 px-4 py-3 text-sm font-bold">
        <span className="flex items-center gap-2">
          {Icon ? <Icon className="h-4 w-4 text-primary" /> : null}
          <span>{title}</span>
        </span>
        <ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open ? <div className="border-t border-border/50 p-4">{children}</div> : null}
    </div>
  );
};
